import config from "../config";
import { storage } from '@/utils/storage'

export function getQueryString(name) {
    // H5: 同时支持 search 与 hash（uni-app 常用 hash 路由：/#/pages/main?adminId=xxx）
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const search = (window.location.search || '').replace(/^\?/, '');
    let r = search.match(reg);
    if (r != null) return decodeURIComponent(r[2]);

    const hash = (window.location.hash || '').replace(/^#/, '');
    const idx = hash.indexOf('?');
    if (idx >= 0) {
        const hashQuery = hash.substring(idx + 1);
        r = hashQuery.match(reg);
        if (r != null) return decodeURIComponent(r[2]);
    }
    return null;
}


export function  redirectToAuthLogin({ svapid,appid } = {}) {
  const finalSvapid = svapid || storage.get('author_wx_appid') || storage.get('svapid')
  const finalAppid = appid || storage.get('appid') || config.wxH5.appId
  const redirectUrl = buildMainLiaoUrl(finalSvapid)
  try {
    const loginUrl =
      config.loginUrl +
      '?redirectUrl=' +
      encodeURIComponent(redirectUrl) +
      '&svapid=' +
      encodeURIComponent(finalSvapid || '') +
      '&appid=' +
      encodeURIComponent(finalAppid || '')
    window.location.replace(loginUrl)
    return
  } catch (e) {
    // fallthrough
  }


}
function buildMainLiaoUrl(svapid) {
  return window.location.origin +'/mainLiao?svapid=' + encodeURIComponent(svapid || '') + '&time=' + encodeURIComponent( Date.now().toString())
}



// WEBPACK FOOTER //
// ./src/utils/common.js